import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { turnOffToast } from "../../store/features/main/mainSlice";
function Toast() {
  const dispatch = useDispatch();
  const { toast } = useSelector((state) => state.main);
  const [show, setShow] = useState(toast.show);
  useEffect(() => {
    if (toast.show) {
      setShow(true);
      const timer = setTimeout(() => {
        handleClose();
      }, 2000);
      return () => clearTimeout(timer);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [toast]);
  const handleClose = () => {
    setShow(false);
    dispatch(turnOffToast());
  };
  if (!show) {
    return null;
  }
  const messageTranslations = {
    EMAIL_IS_EXISTED: "Email đã tồn tại",
    ACCOUNT_NOT_FOUND: "Không tìm thấy tài khoản",
    WRONG_PASSWORD: "Sai mật khẩu",
    LOGIN_SUCCESSFUL: "Đăng nhập thành công",
    PLEASE_LOGIN_AGAIN: "Vui lòng đăng nhập lại",
    USER_NOT_FOUND: "Không tìm thấy người dùng",
    GET_USER_SUCCESS: "Lấy thông tin người dùng thành công",
    GET_USERS_SUCCESS: "Lấy danh sách người dùng thành công",
    SEARCH_USERS_SUCCESS: "Tìm kiếm người dùng thành công",
    CREATE_USER_SUCCESS: "Tạo người dùng thành công",
    UPDATE_USER_SUCCESS: "Cập nhật người dùng thành công",
    DELETE_USER_SUCCESS: "Xóa người dùng thành công",

    NOTE_TITLE_IS_EXISTED: "Tiêu đề ghi chú đã tồn tại",
    NOTE_NOT_FOUND: "Không tìm thấy ghi chú",
    NOTE_CREATED_SUCCESS: "Tạo ghi chú thành công",
    NOTE_UPDATED_SUCCESS: "Cập nhật ghi chú thành công",
    NOTE_DELETED_SUCCESS: "Xóa ghi chú thành công",
    GET_NOTE_SUCCESS: "Lấy ghi chú thành công",
    GET_NOTES_SUCCESS: "Lấy danh sách ghi chú thành công",
    SEARCH_NOTES_SUCCESS: "Tìm kiếm ghi chú thành công",

    NOTE_DETAIL_IS_EXISTED: "Chi tiết ghi chú đã tồn tại",
    NOTE_DETAIL_NOT_FOUND: "Không tìm thấy chi tiết ghi chú",
    NOTE_DETAIL_CREATED_SUCCESS: "Tạo chi tiết ghi chú thành công",
    NOTE_DETAIL_UPDATED_SUCCESS: "Cập nhật chi tiết ghi chú thành công",
    NOTE_DETAIL_DELETED_SUCCESS: "Xóa chi tiết ghi chú thành công",
    GET_NOTE_DETAILS_SUCCESS: "Lấy danh sách chi tiết ghi chú thành công",
    SEARCH_NOTE_DETAILS_SUCCESS: "Tìm kiếm chi tiết ghi chú thành công",
    GET_NOTE_DETAIL_SUCCESS: "Lấy chi tiết ghi chú thành công",

    KEYWORD_REQUIRED: "Từ khóa là bắt buộc",
    WORD_NOT_FOUND: "Không tìm thấy từ",
    WORD_CREATED_SUCCESS: "Tạo từ thành công",
    WORD_UPDATED_SUCCESS: "Cập nhật từ thành công",
    WORD_DELETED_SUCCESS: "Xóa từ thành công",
    GET_WORDS_SUCCESS: "Lấy danh sách từ thành công",
    SEARCH_WORDS_SUCCESS: "Tìm kiếm từ thành công",
    GET_WORD_SUCCESS: "Lấy từ thành công",

    PARAGRAPH_TITLE_IS_EXISTED: "Tiêu đề đoạn văn đã tồn tại",
    PARAGRAPH_NOT_FOUND: "Không tìm thấy đoạn văn",
    PARAGRAPH_CREATED_SUCCESS: "Tạo đoạn văn thành công",
    PARAGRAPH_UPDATED_SUCCESS: "Cập nhật đoạn văn thành công",
    PARAGRAPH_DELETED_SUCCESS: "Xóa đoạn văn thành công",
    GET_PARAGRAPHS_SUCCESS: "Lấy danh sách đoạn văn thành công",
    SEARCH_PARAGRAPHS_SUCCESS: "Tìm kiếm đoạn văn thành công",
    GET_PARAGRAPH_SUCCESS: "Lấy đoạn văn thành công",

    VOCABULARY_IS_EXISTED: "Từ vựng đã tồn tại",
    VOCABULARY_NOT_FOUND: "Không tìm thấy từ vựng",
    VOCABULARY_CREATED_SUCCESS: "Tạo từ vựng thành công",
    VOCABULARY_UPDATED_SUCCESS: "Cập nhật từ vựng thành công",
    VOCABULARY_DELETED_SUCCESS: "Xóa từ vựng thành công",
    GET_VOCABULARIES_SUCCESS: "Lấy danh sách từ vựng thành công",
    SEARCH_VOCABULARIES_SUCCESS: "Tìm kiếm từ vựng thành công",
    GET_VOCABULARY_SUCCESS: "Lấy từ vựng thành công",

    ADMIN_EMAIL_IS_EXISTED: "Email admin đã tồn tại",
    ADMIN_NOT_FOUND: "Không tìm thấy admin",
    ADMIN_WRONG_PASSWORD: "Admin nhập sai mật khẩu",
    ADMIN_LOGIN_SUCCESSFUL: "Admin đăng nhập thành công",
    ADMIN_CREATED_SUCCESS: "Tạo admin thành công",
    ADMIN_UPDATED_SUCCESS: "Cập nhật admin thành công",
    ADMIN_DELETED_SUCCESS: "Xóa admin thành công",
    GET_ADMINS_SUCCESS: "Lấy danh sách admin thành công",
    SEARCH_ADMINS_SUCCESS: "Tìm kiếm admin thành công",
    GET_ADMIN_SUCCESS: "Lấy admin thành công",

    PERMISSION_NAME_IS_EXISTED: "Tên quyền đã tồn tại",
    PERMISSION_NOT_FOUND: "Không tìm thấy quyền",
    PERMISSION_CREATED_SUCCESS: "Tạo quyền thành công",
    PERMISSION_UPDATED_SUCCESS: "Cập nhật quyền thành công",
    PERMISSION_DELETED_SUCCESS: "Xóa quyền thành công",
    ALL_PERMISSIONS_DELETED_SUCCESS: "Xóa tất cả quyền thành công",
    GET_PERMISSIONS_SUCCESS: "Lấy danh sách quyền thành công",
    SEARCH_PERMISSIONS_SUCCESS: "Tìm kiếm quyền thành công",
    GET_PERMISSION_SUCCESS: "Lấy quyền thành công",

    JLPT_VOCAB_WORD_EXISTED: "Từ vựng này đã tồn tại trong cấp độ này",
    JLPT_VOCAB_CREATED_SUCCESS: "Tạo từ vựng JLPT thành công",
    JLPT_VOCAB_NOT_FOUND: "Không tìm thấy từ vựng",
    JLPT_VOCAB_GET_LIST_SUCCESS: "Lấy danh sách từ vựng thành công",
    JLPT_VOCAB_GET_SUCCESS: "Lấy thông tin từ vựng thành công",
    JLPT_VOCAB_UPDATED_SUCCESS: "Cập nhật từ vựng thành công",
    JLPT_VOCAB_DELETED_SUCCESS: "Xoá từ vựng thành công",

    SERVER_ERROR: "Lỗi máy chủ",
    INVALID_REQUEST: "Yêu cầu không hợp lệ",
  };
  return (
    <div className="fixed top-5 left-1/2 -translate-x-1/2 w-fit z-[99999999]">
      {toast.isOk ? (
        <div
          id="toast-success"
          className="flex items-center w-full max-w-lg p-4 mb-4 text-[#9ca3af] bg-green-600 shadow-md rounded-md"
          role="alert"
        >
          <div className="ms-3 text-sm font-normal text-white">
            {!toast.messages
              ? "Thành công !"
              : Object.keys(messageTranslations).includes(toast.messages)
                ? messageTranslations[toast.messages]
                : toast.messages}
          </div>
          <button
            onClick={handleClose}
            type="button"
            className="ms-auto -mx-1.5 -my-1.5 p-1.5 inline-flex items-center justify-center h-8 w-8 text-[#f3f4f6] hover:text-white bg-green-600"
            data-dismiss-target="#toast-success"
            aria-label="Close"
          >
            <span className="sr-only">Close</span>
            <svg
              className="w-3 h-3"
              aria-hidden="true"
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 14 14"
            >
              <path
                stroke="currentColor"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="m1 1 6 6m0 0 6 6M7 7l6-6M7 7l-6 6"
              />
            </svg>
          </button>
        </div>
      ) : (
        <div
          id="toast-danger"
          className="flex items-center w-full max-w-lg p-4 mb-4 text-[#9ca3af] bg-red-600 shadow-md rounded-md"
          role="alert"
        >
          <div
            className="ms-3 text-sm font-normal text-white"
            dangerouslySetInnerHTML={{
              __html: !toast.messages
                ? "Thất bại !"
                : Object.keys(messageTranslations).includes(toast.messages)
                  ? messageTranslations[toast.messages]
                  : toast.messages,
            }}
          ></div>
          <button
            onClick={handleClose}
            type="button"
            className="ms-auto -mx-1.5 -my-1.5 p-1.5 inline-flex items-center justify-center h-8 w-8 text-[#f3f4f6] hover:text-white bg-red-600"
            data-dismiss-target="#toast-danger"
            aria-label="Close"
          >
            <span className="sr-only">Close</span>
            <svg
              className="w-3 h-3"
              aria-hidden="true"
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 14 14"
            >
              <path
                stroke="currentColor"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="m1 1 6 6m0 0 6 6M7 7l6-6M7 7l-6 6"
              />
            </svg>
          </button>
        </div>
      )}
    </div>
  );
}

export default Toast;
